import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme = () => ({
    flexGrow: 1,

    overflow: 'hidden',
});
